import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

function EventPopup({ isPopup, setIsPopup, eventDetail }) {
    const location = useLocation();
    const [popupActive, setPopupActive] = useState(false);

    useEffect(() => {
        const body = document.body;
        body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
            body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        let timeout;
        if (isPopup) {
            timeout = setTimeout(() => {
                setPopupActive(true);
            }, 100);
        } else {
            setPopupActive(false);
        }
        return () => clearTimeout(timeout);
    }, [isPopup]);

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [location]);

    const handleClose = (e) => {
        e.preventDefault();
        setIsPopup(false);
    };

    // 딤 배경 클릭 핸들러 추가
    const handleBackgroundClick = (e) => {
      // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
      if (e.target.className === 'popup-box-component') {
        setIsPopup(false);
      }
    };

    if (isPopup)
        return (
            <div 
              className="popup-box-component"
              onClick={handleBackgroundClick}
            >
                <div className={`box content event support_popup ${popupActive ? 'active' : ''}`}>
                    <div className="popup_container mh_100">
                      <div className="close_btn_con">
                        <button 
                          type="button" 
                          className="close_btn"
                          onClick={handleClose}
                        />
                      </div>
                      <div className='event_inner support_inner credit_list_page'>
                        <div className='event_left'>
                          <h3>{eventDetail?.data?.event_title}</h3>
                          <div className='flex-8 column'>
                            <p className='strong_b1'>이벤트 기간</p>
                            {/* <span className='g-90 b1_2'>{eventDetail?.data?.start_date.split(' ')[0]}~{eventDetail?.data?.end_date.split(' ')[0]}</span> */}
                            <span className='g-90 b1_2'>{eventDetail?.data?.start_date.split(' ')[0]} {eventDetail?.data?.start_date_h}:00~
                            {eventDetail?.data?.end_date ? `${eventDetail?.data?.end_date.split(' ')[0]} ${eventDetail?.data?.end_date_h}:00` : ''}</span>
                          </div>
                          <div className='g-90 b1_2 mt_24'>
                              <div
                                className="event_desc"
                                dangerouslySetInnerHTML={{
                                    __html: (eventDetail?.data?.event_summary || '').replace(/\n/g, '<br />'),
                                }}
                            ></div>
                          </div>
                        </div>
                        <div className='event_right'>
                          <img src={eventDetail?.files[0]?.new_filepath} alt='poster'/>
                        </div>
                      </div>
                    </div>

                    <div className="horizontal_scroll_container">
                        <div className="horizontal_scroll_wrapper">
                          {/* {files.map((image, index) => (
                            <div key={index} className="scroll_item">
                              <img
                                src={image.file_url}
                                alt={`thumbnail-${image.id}`}
                                loading="lazy"
                              />
                            </div>
                          ))} */}
                            <div dangerouslySetInnerHTML={{ __html: eventDetail?.data?.event_content }}></div>

                        </div>
                      </div>
                </div>
            </div>
        );
}

export default EventPopup;
